import React, { Component } from 'react'
import PropTypes from 'prop-types'

const setStateTrigged = (key) => (instance, value) => function() {
  instance.setState({
    [key]: value,
  })
}

const hover = setStateTrigged('hover')

export default (compare) => (WrappedComponent) => {
  return class SelectableList extends Component {
    state = {
      selected: null,
      _lastPropSelected: null,
      hover: false,
      opened: false,
      isClosing: false,
    }

    static propTypes = {
      selected: PropTypes.any,
      onSelect: PropTypes.func,
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.selected && !compare(this.state._lastPropSelected, nextProps.selected)) {
        this.setState({
          selected: nextProps.selected,
          _lastPropSelected: nextProps.selected,
        })
      }
    }

    select = (selected, ...rest) => {
      this.setState({ selected })
      return (
          this.props.onSelect &&
          this.props.onSelect(...[selected, ...rest])
        ) || true;
    }

    isSelected = (item) => compare(item, this.state.selected)

    toggleOpen = () => this.setState({
      opened: !this.state.opened,
    })

    modalClose = () => this.setState({
        isClosing: true,
      }, () => {
        setTimeout(() => {
          this.setState({
            opened: false,
            isClosing: false,
          })
        }, 1000)
      });

    render() {
      const newProps = {
        select: this.select,
        toggleOpen: this.toggleOpen,
        isSelected: this.isSelected,
        modalClose: this.modalClose,
      }
      return (
        <div
          onMouseEnter={hover(this, true)}
          onMouseLeave={hover(this, false)}
        >
          <WrappedComponent
            {...this.props}
            {...this.state}
            {...newProps}
          />
        </div>
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/SelectableList.js